import { render, staticRenderFns } from "./BlipReportsTicketsCount.vue?vue&type=template&id=74afa004&"
import script from "./BlipReportsTicketsCount.vue?vue&type=script&lang=js&"
export * from "./BlipReportsTicketsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports